import React, { useEffect, useRef } from 'react';
import { Animated, Platform } from 'react-native';
import { COLLAPSE_ANIMATION_DURATION } from './constants';

export type InsetOwnProps = {
    isCollapsed: boolean;
};

export type InsetProps = InsetOwnProps;

const EXPANDED_WIDTH = 18;
const COLLAPSED_WIDTH = 6;

const Inset: React.FC<InsetProps> = ({ isCollapsed }) => {
    const insetAnimation = useRef<Animated.Value>(new Animated.Value(isCollapsed ? COLLAPSED_WIDTH : EXPANDED_WIDTH));
    useEffect(() => {
        if (!insetAnimation.current) return;

        Animated.timing(insetAnimation.current, {
            toValue: isCollapsed ? COLLAPSED_WIDTH : EXPANDED_WIDTH,
            duration: COLLAPSE_ANIMATION_DURATION,
            useNativeDriver: Platform.OS === 'web',
        }).start();
    }, [isCollapsed]);

    if (!insetAnimation.current) return null;

    return <Animated.View style={{ width: insetAnimation.current }} />;
};

export default React.memo(Inset);
